import { INewOrder } from "@/interface"

export class ProductPayload {
    public product: {id: number};
    public options: {id: number, combinations: number}[];

    constructor(base?: Partial<ProductPayload>){
        if (base) {
            Object.assign(this, base);
        }
    }

    static toDto(dto: INewOrder) {
        return new ProductPayload({
            product: {id: dto.id},
            options: this.getOptions(dto)
        });
    }

    static getOptions(dto: INewOrder) {
        return [...dto.optionsData, ...dto.optionsOther].map(option => {
            return {
                id: option.id,
                combinations: typeof option.currentActiveOption === "boolean" && option.currentActiveOption ? 1 : (option.currentActiveOption || 0)
            }
        })
    }

}